import {
  StopIcon
} from "./chunk-NXCV5ET6.mjs";
export {
  StopIcon
};
